import MatomoTracker from './MatomoTracker';
import * as types from './types';
export default MatomoTracker;
export { types };
